import axios from 'axios';
import {
  ICatalog,
  ICatalogCollection,
  ICreateCatalogPayload,
  IDeleteCatalogPayload,
  ICatalogListParams,
  IUpdateCatalogPayload,
} from 'entities/Catalog/Catalog.models';

const basePath = 'catalog';

export const catalogTransport = {
  get: (params: ICatalogListParams): Promise<ICatalogCollection> => axios.get(`${basePath}`, { params }),
  getById: (id: number): Promise<ICatalog> => axios.get(`${basePath}/${id}`),
  create: (payload: ICreateCatalogPayload): Promise<ICatalog> => axios.post(`${basePath}`, payload),
  update: (payload: IUpdateCatalogPayload): Promise<ICatalog> => axios.patch(`${basePath}`, payload),
  delete: (payload: IDeleteCatalogPayload): Promise<ICatalog> => axios.delete(`${basePath}`, { data: payload }),
};
